<template>
  <div>
    <div class="navbar" @click="showLang = false">
      <div class="left">
        <img src="@/assets/img/navbar/EQUINOX-logo 1.png" alt="logo" class="logo" />
      </div>
      <div class="right">
        <div class="connect-btn" @click="connectWallet()">
          <img src="@/assets/img/navbar/qianbao-icon.png" alt="wallet" class="wallet-icon" />
          <span>{{ userInfo&&userInfo.address ? shortAddress : $t('navbar.connectWallet') }}</span>
        </div>
        <div class="lang-icon-box" @click.stop="showLang = !showLang">
          <img src="@/assets/img/navbar/yuyan-icon.png" alt="lang" class="lang-icon" />
          <div class="lang-popup" v-show="showLang">
            <div class="lang-item" @click.stop="setLanguage('en')" :class="{ active: lang === 'en' }">{{ $t('navbar.langEn') }}</div>
            <div class="lang-item" @click.stop="setLanguage('zh')" :class="{ active: lang === 'zh' }">{{ $t('navbar.langZh') }}</div>
            <div class="lang-item" @click.stop="setLanguage('ko')" :class="{ active: lang === 'ko' }">{{ $t('navbar.langKo') }}</div>
            <div class="lang-item" @click.stop="setLanguage('ja')" :class="{ active: lang === 'ja' }">{{ $t('navbar.langJa') }}</div>
          </div>
        </div>
        <div class="lang-mask" v-show="showLang" @click="showLang = false"></div>
      </div>
    </div>

    <Popover ref="inviteModal" :maskClosable="false" :closable="false">
      <div class="invite-modal">
        <h3 class="invite-title">{{ $t('modal.invite.title') }}</h3>
        <div class="invite-input-wrap">
          <input
            class="invite-input"
            type="text"
            v-model.trim="inviteInput"
            :placeholder="$t('modal.invite.placeholder')"
            :maxlength="12"
            autocomplete="off"
          />
        </div>
        <div class="invite-hint">{{ $t('modal.invite.formatHint') }}</div>
        <div class="invite-actions">
          <div class="invite-btn confirm" @click="onInviteConfirm">{{ $t('modal.invite.confirm') }}</div>
        </div>
        <div class="invite-footer">{{ $t('modal.invite.noCodeHint') }}</div>
      </div>
    </Popover>
    <Popover ref="account_banned" :maskClosable="false" :closable="false" :zIndex="1000">
      <img src="@/assets/img/popover/warning.png" class="banned_icon" />
      <div class="banned_text">{{ $t('common.accountBanned') }}</div>
    </Popover>
    <Popover ref="user_relogin" :maskClosable="false" :closable="false" :zIndex="1000">
      <img src="@/assets/img/popover/warning.png" class="banned_icon" />
      <div class="banned_text">{{ text }}</div>
      <div class="reload-btn" @click="reloadPage">{{ $t('common.confirm') }}</div>
    </Popover>

  </div>
</template>

<script>
import { createAppKit } from '@reown/appkit'
import { EthersAdapter } from '@reown/appkit-adapter-ethers'
import { bsc } from '@reown/appkit/networks'
import { ethers } from 'ethers'
import { CHAIN_CONFIG } from '@/config/chain'
import Popover from '@/components/popover.vue'

const projectId = CHAIN_CONFIG.projectId

export default {
  name: 'Navbar',
  components: {
    Popover
  },
  data() {
    return {
      showLang: false,
      modal: null,
      appKitSubscribed: false,
      lastWalletAddress: '',
      inviteInput: '',
      inviteResolve: null,
      text: '',
      lang: ''
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
    isConnected() {
      return this.$store.getters.isWalletConnected && localStorage.getItem('@appkit/connection_status') == 'connected'
    },
    shortAddress() {
      return this.$store.getters.shortWalletAddress
    },
    relogin() {
      return this.$store.state.relogin
    },
  },
  watch: {
    isConnected() {
      var connection_status = localStorage.getItem("@appkit/connection_status")
      setTimeout(() => {
        if(!this.isConnected&&connection_status!='connected'){
          localStorage.removeItem('BearerToken')
        }
      }, 500)
      this.$emit('changeConnect')
    },
    relogin() {
      this.text = this.$getMsg(1112)
      this.$message(
        {
          message: this.text,
          type: 'error',
          duration: 3000,
        }
      )
      setTimeout(() => {
        this.reloadPage()
      }, 3000)  
    },
  },
  async mounted() {
    this.lang = localStorage.getItem('lang') || 'en'
    // this.initAppKit(true)
    // await this.$store.dispatch('initWallet')
    // const addr = this.$store.getters.walletAddress
    // const token = localStorage.getItem('BearerToken')
    // const userInfo = this.$store.getters.userInfo
    // if (addr && token && !userInfo) {
    //   this.getUserInfo(addr)
    // }
  },
  methods: {
    reloadPage() {
      window.location.reload()
    },
    initAppKit(isOne = false) {
      if (this.modal||this.$store.state.userInfo) return
      this.modal = createAppKit({
        adapters: [new EthersAdapter()],
        networks: [bsc],
        projectId,
        themeMode: 'dark',
        // debug: false,
        enableWalletConnect: false,
        enableCoinbase: false,
        enableInjected: true,
        enableEIP6963: true,
        customRpcUrls: {
          'eip155:56': [
            { url: 'https://bsc-dataseed.binance.org' },
            { url: 'https://bsc.publicnode.com' }
          ]
        },
        features: {
          email: false,
          socials: false
        }
      })

      if (this.appKitSubscribed) return
      this.appKitSubscribed = true
      this.modal.subscribeAccount(state => {
        const isConnected = !!state && !!state.isConnected
        const address = state && state.address ? state.address : ''
        this.$store.commit('SET_WALLET', { isConnected, address })

        try {
          const provider = this.modal.getWalletProvider()
          if (provider) window.ethereum = provider
        } catch (e) {}

        const prev = this.lastWalletAddress
        this.lastWalletAddress = address

        if (!isConnected) {
          // localStorage.removeItem('BearerToken')
          localStorage.removeItem('inviteCode')
          this.$store.commit('setUserInfo', null)
          if (this.$refs.inviteModal) this.$refs.inviteModal.close()
          return
        }

        if (prev && address && prev.toLowerCase() !== address.toLowerCase()) {
          // localStorage.removeItem('BearerToken')
          localStorage.removeItem('inviteCode')
          this.$store.commit('setUserInfo', null)
          return
        }

        const token = localStorage.getItem('BearerToken')
        const userInfo = this.$store.getters.userInfo
        const connectState = localStorage.getItem('@appkit/connection_status')
        const inviteCode = localStorage.getItem('inviteCode')
        if (token && address && !userInfo && inviteCode && connectState=='connected') {
          this.getUserInfo(address)
        }
      })
    },
    setLanguage(lang) {
      this.$i18n.locale = lang
      localStorage.setItem('lang', lang)
      this.lang = lang
      this.showLang = false
      this.$store.state.changeLang+=1
    },
    async connectWallet(inviteCode) {
      try {
        this.initAppKit()
        if (this.modal) this.modal.open()

        const address = await this.waitForConnectedAddress()
        if (!address) return

        await this.connectAndLogin(address, inviteCode)
      } catch (e) {
        this.$message({
          message: e.message || this.$t('navbar.connectFailed'),
          type: 'error'
        })
      }
    },
    waitForConnectedAddress() {
      const fromStore = this.$store.getters.walletAddress
      if (fromStore) return Promise.resolve(fromStore)

      return new Promise(resolve => {
        const started = Date.now()
        const timer = setInterval(() => {
          const addr = this.$store.getters.walletAddress
          if (addr) {
            clearInterval(timer)
            resolve(addr)
            return
          }
          if (Date.now() - started > 60000) {
            clearInterval(timer)
            resolve('')
          }
        }, 300)
      })
    },
    async getSigner() {
      this.initAppKit()
      if (!this.modal) throw new Error(this.$t('common.walletNotConnected'))
      const walletProvider = this.modal.getWalletProvider()
      if (!walletProvider) throw new Error(this.$t('common.walletNotConnected'))
      const provider = new ethers.BrowserProvider(walletProvider)
      return await provider.getSigner()
    },
    async connectAndLogin(address, inviteCode) {
      const addr = address || this.$store.getters.walletAddress
      if (!addr) return

      const token = localStorage.getItem('BearerToken')
      if (token) {
        const userInfo = this.$store.getters.userInfo
        if (!userInfo) await this.getUserInfo(addr)
        return
      }

      const nonceResp = await this.$post('/user/get_nonce', { address: addr })
      const nonce = nonceResp?.data?.nonce || nonceResp?.nonce || (typeof nonceResp?.data === 'string' ? nonceResp.data : '')
      if (!nonce) {
        this.$message({ message: this.$t('navbar.nonceFailed'), type: 'error' })
        return
      }

      const signer = await this.getSigner()
      const signature = await signer.signMessage(nonce)

      const tryLogin = async (code) => {
        const form = new URLSearchParams({
          address: addr,
          signature,
          invite_code: code || ''
        })
        const resp = await this.$axios.post('/user/login', form)
        return resp && resp.data ? resp.data : resp
      }

      const first = await tryLogin(inviteCode || '')
      if(first?.code == 1104){
        this.$refs.account_banned.open()
        return
      }
      if(first?.code == 1112){
        this.text = this.$getMsg(1112)
        this.$message(
          {
            message: this.text,
            type: 'error',
            duration: 3000,
          }
        )
        setTimeout(() => {
          this.reloadPage()
        }, 3000) 
        return
      }
      const firstToken = first?.data?.token || first?.token
      if (firstToken) {
        localStorage.setItem('BearerToken', 'Bearer ' + firstToken)
        await this.getUserInfo(addr)
        return
      }

      const fromUrl = this.getInviteCodeFromUrl()
      const saved = localStorage.getItem('inviteCode')
      const initial = inviteCode || fromUrl || saved || ''
      const code = await this.openInviteModal(initial)
      if (!code) return
      localStorage.setItem('inviteCode', code)

      const second = await tryLogin(code)
      const secondToken = second?.data?.token || second?.token
      if (!secondToken) {
        this.$message({ message: this.$t('navbar.loginFailed'), type: 'error' })
        return
      }

      localStorage.setItem('BearerToken', 'Bearer ' + secondToken)
      await this.getUserInfo(addr)
    },
    getInviteCodeFromUrl() {
      try {
        const search = window.location.search || ''
        const fromSearch = new URLSearchParams(search).get('inviteCode')
        if (fromSearch){ 
          localStorage.setItem('inviteCode', fromSearch || '')
          return fromSearch
        }

        const hash = window.location.hash || ''
        const idx = hash.indexOf('?')
        if (idx >= 0) {
          const qs = hash.slice(idx + 1)
          const fromHash = new URLSearchParams(qs).get('inviteCode')
          if (fromHash){ 
            localStorage.setItem('inviteCode', fromHash || '')
            return fromHash
          }
        }
      } catch (e) {
        return ''
      }
      return ''
    },
    openInviteModal(initialCode) {
      if (!this.$refs.inviteModal) return Promise.resolve('')
      this.inviteInput = initialCode || ''
      this.$refs.inviteModal.open()
      return new Promise(resolve => {
        this.inviteResolve = resolve
      })
    },
    onInviteConfirm() {
      const v = (this.inviteInput || '').trim()
      const ok = /^[a-zA-Z0-9]{6,12}$/.test(v)
      if (!ok) {
        this.$message({ message: this.$t('modal.invite.invalidFormat'), type: 'warning' })
        return
      }
      if (this.$refs.inviteModal) this.$refs.inviteModal.close()
      if (this.inviteResolve) {
        const r = this.inviteResolve
        this.inviteResolve = null
        r(v)
      }
    },
    async getUserInfo(address){
      const token = localStorage.getItem('BearerToken')
      if (!token) return
      const res = await this.$post('/user/info', { address })
      
      if (res && res.code === 0) {
        const userInfo = res?.data
        if (!userInfo) {
          this.$message({ message: this.$t('navbar.userInfoFailed'), type: 'error' })
          return
        }
        this.$store.state.userInfo = userInfo
        this.$forceUpdate()
        return
      }else{
        if(res.code == 1104){
          this.$refs.account_banned.open()
        }
      }
    }
  }
};
</script>

<style scoped lang="scss">
.banned_icon{
    width: 160px;
    height: 80px;
    display: block;
}
.banned_text{
  color: #FFF;
  text-align: center;
  font-family: "Alibaba PuHuiTi 2.0";
  font-size: 20px;
  font-style: normal;
  font-weight: 900;
  line-height: 20px; /* 100% */
}
.invite-modal{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.invite-title{
  font-family: "Alibaba PuHuiTi 2.0";
  font-weight: 900;
  font-size: 24px;
  color: #fff;
  text-align: left;
  margin: 0 0 32px 0;
}

.invite-input-wrap{
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 10px 0;
  margin-bottom: 12px;
}

.invite-input{
  width: 100%;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 16px;
  font-family: "PingFang SC";
  font-weight: 600;
  &::placeholder{
    color: #fff;
    opacity: 0.5;
  }
}

.invite-hint{
  font-size: 14px;
  color: #999;
  text-align: left;
  margin: 0 0 32px 0;
  font-family: "PingFang SC";
}

.invite-actions{
  display: flex;
  gap: 24px;
  margin-bottom: 16px;
}

.invite-btn{
  flex: 1;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  font-family: "PingFang SC";
  box-sizing: border-box;
  &.confirm{
    background: #FF401A;
    color: #fff;
  }
}

.invite-footer{
  font-size: 14px;
  color: #999;
  text-align: center;
  font-family: "PingFang SC";
}

.reload-btn{
  background: #FF401A;
  border-radius: 8px;
  padding: 15px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: #000; /* Fixed background color */
  position: fixed; /* Fixed at the top */
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  box-sizing: border-box;
  border-bottom: 0.75px solid rgba(255, 64, 26, 0.20);

  .left {
    display: flex;
    align-items: center;
    .logo {
      height: 24px; /* Adjust based on visual */
    }
  }
  .right {
    display: flex;
    align-items: center;
    gap: 10px;

    .connect-btn {
      display: flex;
      align-items: center;
      background: #FF401A;
      border-radius: 4px;
      height: 32px;
      padding: 0 12px;
      color: #fff;
      font-size: 12px;
      gap: 4px;
      cursor: pointer;

      .wallet-icon {
        width: 16px;
        height: 16px;
      }
    }
    .lang-mask{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 100;
    }
    .lang-icon-box{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 32px;
      height: 32px;
      border-radius: 6px;
      border: 1px solid #FF401A;
      box-sizing: border-box;
      position: relative;
      cursor: pointer;
      z-index: 101;

      .lang-popup{
        position: absolute;
        top: 100%;
        right: 0;
        padding: 6px;
        margin-top: 6px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border-radius: 16px;
        border: 1px solid rgba(255, 255, 255, 0.10);
        background: #17161A;
        gap: 4px;
        z-index: 101;
        .lang-item{
          padding: 8px 16px;
          white-space: nowrap;
          font-size: 16px;
          width: 100%;
          box-sizing: border-box;
          &.active{
            border-radius: 12px;
            background: #FF401A;
          }
        }
      }
    }
    .lang-icon {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
